import { h, Component, Fragment } from 'preact';
import logo from './../../assets/intl-tsunami-symbol.svg';
import facebook from './../../assets/facebook-logo.svg';
import twitter from './../../assets/twitter-logo.svg';
import { regions } from './../config/config.js';

export default class HeaderComponent extends Component {
    constructor() {
        super();
        this.navigationButtons = [];
        this.state = {
            showNavigation: false
        };
    }

    toggleMobileNavigation() {
        this.setState({ showNavigation: !this.state.showNavigation });
    }

    render() {
        const self = this;
        return (
            <Fragment>
                <header class="site-header" role="banner">

                    {/* BRANDING */}
                    <hgroup class="brand float-left">

                        <span class="logo float-left">
                            <img src={logo} alt="International Tsunami Symbol" width="85" />
                        </span>

                        <h1>Tsunami Aware</h1>

                    </hgroup>

                    {/* MOBILE MENU TOGGLE */}
                    <div>

                        <button role="button" class="mobilize-toggle float-right" onclick={() => self.toggleMobileNavigation()}>
                            Maps
                            <span class="text-hidden">Menu</span>
                        </button>

                        <div class={`mobilize dropdown-menu ${self.state.showNavigation ? 'is-open' : ''}`}>

                            {/* SITE NAV */}
                            <nav class="site-header-nav" role="navigation">
                                {regions.map(region => {
                                        return <button key={region.name} ref={r => self.navigationButtons.push(r)}
                                            class={self.props.selectedRegion && region.name === self.props.selectedRegion.name ? 'active' : ''}
                                            onclick={() => self.props.onChangeRegion(region)} data-ga={`Nav: ${region.title}`}
                                        >{region.name}</button>;
                                })}
                            </nav>
                        </div>{/* /mobilize */}

                    </div>

                    {/* DESKTOP SHARE MENU TOGGLE */}
                    <div class="share-tools float-right">
                        {/* Jira TIS-106 */}
                        <a href={'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Ftsunami.coast.noaa.gov%2F#/'}
                            target="_blank" rel="noreferrer" class="share-link" button-click-animation data-ga="Share: Facebook">
                            <img src={facebook} alt="Share on Facebook" />
                        </a>
                        <a href={'https://twitter.com/intent/tweet?user-share&text=Use%20this%20mobile%20app%20to%20explore%20tsunami%20evacuation%20zones%20for%20Guam%20and%20Hawaii&tw_p=tweetbutton&url=https%3A%2F%2Ftsunami.coast.noaa.gov/'}
                            target="_blank" rel="noreferrer" class="share-link" button-click-animation data-ga="Share: Twitter">
                            <img src={twitter} alt="Share on Twitter" />
                        </a>
                    </div>
                </header>
            </Fragment>
        );
    }
}
